export default (vehicle: { year: number; make: string; model: string }) => {
  const vehicleString = [vehicle.year, vehicle.make, vehicle.model]
    .join("-")
    .toLowerCase()
    .replace(/ /g, "-");
  return encodeURIComponent(vehicleString);
};
